import { html, LitElement } from 'lit';
import { customElement } from 'lit/decorators';

import '@carbon/web-components/es/components/tile/tile.js';
import '@carbon/web-components/es/components/progress-indicator';
import '@carbon/web-components/es/components/code-snippet/code-snippet.js';

import { unsafeHTML } from 'lit-html/directives/unsafe-html';
import '../flow/pdq-json';
import '../flow/pdq-view';
import '../flow/pdq-perspective-viewer';
import './PDQCodeHtml';


@customElement('pdq-tutorial-view')
export class PDQTutorialView extends LitElement {
  render() {
    const code = `<pdq-json id="people"><template>
[
  {
    "name": "Alice",
    "age": 25
  },
  {
    "name": "Bob",
    "age": 30
  },
  {
    "name": "Charley",
    "age": 30
  }
]
</template></pdq-json>

<pdq-view table="people" id="people-over-25">
<script type="application/json">
{
  "filter":[["age",">","25"]]
}
</script>
</pdq-view>


<pdq-dump id="dump-people" table="people" show="1"></pdq-dump>
<pdq-dump id="dump-people-by-age" table="people-over-25" show="1"></pdq-dump>
`;

    const code2 = `  
// create a view with filter 
const v1 = await window.pdqDataBroker.getOrCreateView('filtered-posts', 'posts-table', {filter: [["userId", "==", 6]]});

// get an existing view (the same view)
const v2 = await window.pdqDataBroker.getOrCreateView('filtered-posts');
`


    return html`
      <cds-tile>
        <h2>Views</h2>
        
        <p>Views are projections of tables via perspective config, filter, group by, sort etc.</p>
        <p>Here we are using a table from json, and the dumping it via pdq-dump (a normally indivisible debug component)</p>
        <pdq-code-html code="${code}"></pdq-code-html>
        ${unsafeHTML(code)}
        <p>One dump is using the table directly, the second is using the view</p>
        <p>Views also create dependent tables called {id}-result-table </p>
        <pdq-perspective-viewer id="grouped-view" height="220px" table="people-over-25-result-table"></pdq-perspective-viewer>
        <p>Views can be created by using the pdq-view declaratively in markup, or directly on the global data model 
          using window.pdqDataBroker</p>
        <pdq-code-html code="${code2}"></pdq-code-html>
      </cds-tile>
    `;
  }
}

